<template>
  <div id="about">
    <div id="p1">
      <h1 id="title">
        Hello
        <p id="nameTag">
          I AM SIMON!
        </p>
      </h1>
    </div>
    <div id="p2">
      <p class="size1">
        A FREELANCE
      </p>
      <p class="size1">
        AND
      </p>
      <p class="size1">
        CREATIVE
      </p>
      <p class="size1 space">
        DEVELOPER.
      </p>
      <p class="size2 space maxWidth">THIS MEANS THAT I LOVE CREATING AND I AM EFFICIENT AT MAKING COMPLEX ANIMATIONS AND 3D CONTENT.</p>
      <p class="size2 maxWidth">
        IF YOU WANT TO TALK ABOUT YOUR PROJECT, 
        <a id="textMe" class="size2" href="mailto:simon.tessier8@gmail.com" target="_blank">
        TEXT ME!
        </a>
      </p>
    </div>
    <footer id="footer">
      <p>
        BASED IN FRANCE
      </p>
      <div id="socials">        
        <a href="https://twitter.com/Simon349_" target="_blank">twitter.</a>
        <a href="mailto:simon.tessier8@gmail.com" target="_blank">email.</a>
        <a href="https://github.com/Wizer21" target="_blank">github.</a>
      </div>
    </footer>
  </div>
</template>

<script>
import World from '../scripts3D/World.js'
import Loader from '../utils/Loader.js'

export default {
  name: 'About',
  mounted(){
    document.title = 'SI. /ABOUT'
    const loader = new Loader()
    loader.open()

    const world = new World()
    world.renderProjects = false
    world.renderHome = false
    
    loader.close()
  }
}
</script>

<style scoped>
#about
{
  height: 100vh;
  width: 100vw;

  display: flex;
  flex-direction: column;
}
#title
{
  margin: 0;
}
#nameTag
{
  margin: 0;
}
#p2 *
{
  margin: 0;
}
#textMe
{
  color: #111111;
  text-decoration: underline;
  white-space: nowrap;
}
/* Footer */
#footer
{
  position: fixed;
  bottom: 0;

  width: 100vw;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
#footer p
{
  margin: 0;
}
#socials a
{
  color: #111111;
  margin-left: 2vh;
  text-decoration: underline;
}
@media (min-aspect-ratio: 5/8) {
  #about
  {
    justify-content: center;
  }
  #p1
  {
    width: 50vw;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .size1
  {
    font-size: 3.5vh;
  }
  .size2
  {
    font-size: 1.5vh;
  }
  #p2
  {
    margin-left: 50vw;
  }
  .space
  {
    margin-bottom: 4vh !important;
  }
  .maxWidth
  {
    max-width: 30vw;
  }
  #title
  {
    font-size: 20vh;
  }
  #nameTag
  {
    font-size: 3vh;

    margin-top: -3vh;
    margin-left: 1.5vh;
  }
  #footer
  {
    padding: 3vh;
  }
  @media (max-aspect-ratio: 8/8) {    
    #title
    {
      font-size: 20vw;
    }
    #nameTag
    {
      margin-top: -1.5vw;
    }
  }
}
@media (max-aspect-ratio: 5/8) {
  .size1
  {
    font-size: 7vw;
  }
  .size2
  {
    font-size: 3vw;
  }
  #p1
  {    
    margin: 8vh 0;
  }
  #p2
  {
    margin: 8vh 0;
    margin-left: 40vw;
  }
  .space
  {
    margin-bottom: 4vw !important;
  }
  .maxWidth
  {
    max-width: 50vw;
  }
  #title
  {
    font-size: 40vw;
  }
  #nameTag
  {
    font-size: 8vw;

    margin-top: -5vw;
    margin-left: 8vw;
  }
  #footer
  {
    padding: 1.5vh;
  }
  #footer *
  {
    font-size: 4vw;
  }
}
</style>